/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Tab_FinanceInputs */

const en_setup_tab_finance = /** @type {(inputs: Setup_Tab_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance`)
};

/**
* | output |
* | --- |
* | "Finance" |
*
* @param {Setup_Tab_FinanceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_tab_finance = /** @type {((inputs?: Setup_Tab_FinanceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Tab_FinanceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_tab_finance(inputs)
});